import { 
  Users, 
  Monitor, 
  Clock, 
  Zap, 
  Settings, 
  User 
} from "lucide-react";

const formats = [
  {
    icon: Users,
    title: "In-person Workshops",
    description: "Full embodiment and connection in physical space",
  },
  {
    icon: Monitor,
    title: "Online Sessions",
    description: "Flexible, accessible sessions via video",
  },
  {
    icon: Clock,
    title: "Half-day / Full-day",
    description: "Immersive deep-dive workshops",
  },
  {
    icon: Zap,
    title: "Masterclasses",
    description: "Focused short sessions on specific skills",
  },
  {
    icon: Settings,
    title: "Bespoke Programmes",
    description: "Tailored series designed for your organisation",
  },
  {
    icon: User,
    title: "1:1 Coaching",
    description: "Individual attention and personalised development",
  },
];

export default function FormatsSection({ isVisible }) {
  return (
    <section
      id="formats"
      className={`py-24 lg:py-32 bg-[#F9F6F0] transition-all duration-700 ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      }`}
      data-testid="formats-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-['Cormorant_Garamond'] text-3xl sm:text-4xl lg:text-5xl font-medium text-[#1A1A1A] mb-6 heading-decorated-center">
            Formats
          </h2>
          <p className="font-['Manrope'] text-base lg:text-lg text-[#4A4542] max-w-2xl mx-auto">
            I offer flexible formats to suit different needs, from intensive
            in-person workshops to ongoing coaching relationships.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {formats.map((format, index) => (
            <div
              key={format.title}
              className="flex items-start p-6 bg-[#EAE3D9]/50 hover:bg-[#EAE3D9] transition-colors"
              data-testid={`format-card-${index}`}
            >
              <format.icon
                size={24}
                strokeWidth={1.5}
                className="text-[#8B5A2B] mr-4 mt-1 flex-shrink-0"
              />
              <div>
                <h3 className="font-['Cormorant_Garamond'] text-lg font-medium text-[#1A1A1A] mb-1">
                  {format.title}
                </h3>
                <p className="font-['Manrope'] text-sm text-[#4A4542]">
                  {format.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
